import React from "react";
import {
  Box,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import Seo from "../components/Seo";
import ContactForm from "../components/ContactForm";
import { SITE } from "../data/site";
import { buildBreadcrumbSchema, buildContactPageSchema, buildWebPageSchema } from "../utils/schema";

export default function Contact() {
  const title = "Contact — Brainwave Solutions";
  const description = "Contact Brainwave Solutions to discuss a project.";
  const canonical = "https://brainwavesolutions.net/contact";
  const structuredData = [
    buildWebPageSchema({ title, description, canonical, type: "ContactPage" }),
    buildContactPageSchema(canonical),
    buildBreadcrumbSchema([
      { name: "Home", url: SITE.url },
      { name: "Contact", url: canonical },
    ]),
  ];

  return (
    <>
      <Seo
        title={title}
        description={description}
        canonical={canonical}
        structuredData={structuredData}
      />

      <Box sx={{ paddingTop:'10px' }}>
        <Container maxWidth="md">
          <Stack spacing={1.2} sx={{ mb: 3 }}>
            <Typography variant="h1">
              Contact
            </Typography>
          </Stack>

          <ContactForm />
        </Container>
      </Box>
    </>
  );
}
